import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import subscriptionService from "@/services/api/subscription";
import type { GetSubscriptionPlansParams, SubscriptionPlan } from "@/services/api/subscription";

export interface SubscriptionState {
  plans: SubscriptionPlan[];
  totalPlans: number;
  isFetching: boolean;
  error: string | null;
}

const initialState: SubscriptionState = {
  plans: [],
  totalPlans: 0,
  isFetching: false,
  error: null,
};

export const getSubscriptionPlans = createAsyncThunk(
  "subscription/getSubscriptionPlans",
  async (params: GetSubscriptionPlansParams | undefined) => subscriptionService.getSubscriptionPlans(params),
);

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSubscriptionPlans.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(getSubscriptionPlans.fulfilled, (state, action) => {
        state.isFetching = false;
        state.plans = action.payload?.data?.results ?? [];
        state.totalPlans = action.payload?.data?.totalRecord ?? state.plans.length;
      })
      .addCase(getSubscriptionPlans.rejected, (state, action) => {
        state.isFetching = false;
        state.plans = [];
        state.error = action.error.message ?? "Failed to load subscription plans";
      });
  },
});

export default subscriptionSlice.reducer;
